export default __webpack_public_path__ + "static/media/kiwi_Icon.9e1d2a6d.png";